import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';

import { BatchCheckboxComponent } from './batch-checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule
  ],
  exports: [
    BatchCheckboxComponent
  ],
  declarations: [
    BatchCheckboxComponent
  ]
})
export class BatchCheckboxModule { }
